import type { Language } from '@offer-catalog/services/i18n'
import type { ChipFamilyType } from './Families'
import { VpButton, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useOverflowList } from 'react-responsive-overflow-list'
import { FamilyChip } from './FamilyChip'
import './families.scss'

export interface FamiliesFooterProps {
  families: ChipFamilyType[]
  toggleFamily: (family: ChipFamilyType) => void
  setOpenModal: (open: boolean) => void
  goToProductPage: () => void
}

export function FamiliesFooter({
  families,
  toggleFamily,
  setOpenModal,
  goToProductPage,
}: Readonly<FamiliesFooterProps>) {
  const { i18n, t } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language
  const {
    containerRef,
    overflowIndicatorRef,
    visibleCount,
    hiddenCount,
    phase,
    showOverflow,
  } = useOverflowList<HTMLDivElement, HTMLButtonElement>({
    itemCount: families.length,
    maxRows: 1,
  })

  return (
    <footer data-testid="families-footer" className="families-footer">
      <div
        ref={containerRef}
        className="families-chip"
      >
        {families.map((family, index) => {
          const visible = phase === 'measuring' || index < visibleCount
          if (!visible)
            return null

          return (
            <FamilyChip
              key={family.id}
              color="inverse"
              label={family.labels[currentLanguage]}
              remove={() => toggleFamily(family)}
            />
          )
        })}
        {showOverflow && (
          <VpButton
            ref={overflowIndicatorRef}
            className="families-overflow-btn"
            data-testid="families-overflow_button"
            onClick={() => setOpenModal(true)}
          >
            +
            {hiddenCount}
            {' '}
            {t('more')}
          </VpButton>
        )}
      </div>
      <VpButton
        variant="secondary"
        className="families-footer-btn-lets-go"
        data-testid="btn-lets-go"
        onClick={goToProductPage}
      >
        {t('letsgo')}
        <VpIcon name="chevron-forward" />
      </VpButton>
    </footer>
  )
}
